import { BenQuery } from './BenQuery'
import { BenSwiper } from './BenSwiper'
export class BenSw {
  static init(dones, app) {
    const $sw = BenQuery.query('[ben-js="sw"]')
    $sw.forEach(($item) => {
      if (dones.includes($item)) return
      dones.push($item)
      _init($item)
    })
  }
}

async function _init($sw: HTMLElement) {
  const type = $sw.getAttribute('type')
  const perView = $sw.getAttribute('per-view') || undefined
  const effect = $sw.getAttribute('effect') || undefined
  const spaceBetween = Number($sw.getAttribute('between')) || 0
  const loop = $sw.hasAttribute('loop')
  const innerHTML = $sw.innerHTML
  const preAddHtml = `<div class="pagination"></div>
        <div class="prev btn">
          <svg><use xlink:href="#icon-next"></use></svg>
        </div>
        <div class="next btn">
          <svg><use xlink:href="#icon-next"></use></svg>
        </div>`
  $sw.innerHTML = preAddHtml + innerHTML
  await BenQuery.nextTick()
  const pagination = $sw.querySelector(':scope > .pagination')
  const prevEl = $sw.querySelector(':scope > .prev')
  const nextEl = $sw.querySelector(':scope > .next')
  const $swiper = $sw.querySelector('.swiper') as HTMLElement
  if (type === 'coverflow') {
    BenSwiper.initCoverflow($swiper, { spaceBetween, pagination, prevEl, nextEl, perView, loop })
  } else if (type === 'normal') {
    BenSwiper.init($swiper, { spaceBetween, pagination, prevEl, nextEl, loop, perView, effect })
  }
}
